import PropTypes from 'prop-types';
import React, { Component } from 'react';
import StaticContainer from 'react-static-container';
import debounce from 'lodash/debounce';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

/* istanbul ignore next */
const getAssetData = (productImages) => {
    let assetData = '';
    // capture part of string
    // JCPenney/DP0519201717144822M
    const strPattern = /JCPenney\/[^?]*/g;
    productImages.forEach((productImage) => {
        const Url = productImage.url;
        const assetUrl = Url.match(strPattern);
        assetData += assetUrl[0];
        assetData += ',';
    });
    return assetData;
};
/* global  s7viewers:true */
/* istanbul ignore next */
export default class InlineImageZoom extends Component {
    static defaultProps = {
        productImage: null,
        containerId: null,
        initCallBack: null,
    };

    static propTypes = {
        productImage: PropTypes.string,
        containerId: PropTypes.string.required,
        initCallBack: PropTypes.func,
    };

    constructor() {
        super();
        this.initiateZoomViewer = debounce(this.initiateZoomViewer, 100);
    }

    componentDidMount() {
        this.zoomViewerLoad().then(this.initiateZoomViewer);
    }

    componentDidUpdate() {
        this.zoomViewerLoad().then(this.initiateZoomViewer);
    }

    componentWillUnmount() {
        this.zoomViewer && this.zoomViewer.dispose();
    }

    initiateZoomViewer = () => {
        const assetData = getAssetData([this.props.productImage]);
        this.zoomViewer && this.zoomViewer.dispose();
        this.zoomViewer = new s7viewers.BasicZoomViewer({
            containerId: this.props.containerId,
            params: {
                asset: assetData,
                serverurl: 'https://jcpenney.scene7.com/is/image/',
                doubleclick: 'zoom',
            },
        });
        // set size explicit to 0 here to avoid
        // conflict from query string size.

        this.zoomViewer.setParam('size', 0);
        this.zoomViewer.setHandlers({
            initComplete: () => {
                if (this.props.initCallBack) {
                    this.props.initCallBack();
                }
            },
        });
        this.zoomViewer.init();
    };

    zoomViewerLoad = () => { // eslint-disable-line
        return new Promise((resolve) => {
            if (!window.s7viewers) {
                const ZoomViewerScript = {
                    src: 'https://jcpenney.scene7.com/s7viewers/html5/js/BasicZoomViewer.js',
                    async: true,
                    defer: false,
                    onSuccess: resolve,
                };
                ScriptLoader.load(ZoomViewerScript);
            } else {
                resolve();
            }
        });
    };

    render() {
        return (
            <StaticContainer>
                <div
                    id={this.props.containerId}
                    data-automation-id="container"
                    className={dt(['absolute', 'left-0'])}
                />
            </StaticContainer>
        );
    }
}
